import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import GlJournalSchemeService from "services/Setup/Jurnal/GlJournalSchemeService";

export const initialState = {
  loading: false,
  error: null,
  glJournalSchemeList: [],
  glJournalSchemeCount: 0,
};

const toListAndCount = (response) => {
  const payload = response?.data;
  if (payload && Array.isArray(payload.data)) {
    return { list: payload.data, count: payload.count ?? payload.data.length };
  }
  if (Array.isArray(payload)) return { list: payload, count: payload.length };
  return { list: [], count: 0 };
};

export const getGlJournalSchemeList = createAsyncThunk(
  "glJournalScheme/getGlJournalSchemeList",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await GlJournalSchemeService.getGlJournalSchemeList(params);
      return toListAndCount(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const GlJournalSchemeSlice = createSlice({
  name: "glJournalScheme",
  initialState,
  reducers: {
    clearGlJournalSchemeList: (state) => {
      state.glJournalSchemeList = [];
      state.glJournalSchemeCount = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGlJournalSchemeList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGlJournalSchemeList.fulfilled, (state, action) => {
        state.loading = false;
        state.glJournalSchemeList = action.payload.list;
        state.glJournalSchemeCount = action.payload.count;
      })
      .addCase(getGlJournalSchemeList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Gagal memuat GL journal scheme";
      });
  },
});

export const { clearGlJournalSchemeList } = GlJournalSchemeSlice.actions;

export default GlJournalSchemeSlice.reducer;
